export default __webpack_public_path__ + "bebb1feb9ca67a6de7c666a817aec366.svg";